/// <summary>
/// 驾车类型
/// </summary>
export const DriveStyle = {


	/// <summary>
	/// 避开高速
	/// </summary>
	AvoidHighways: "2",
	/// <summary>
	/// 最短距离
	/// </summary>
	LeastDistance: "1",
	/// <summary>
	/// 最少时间（最快线路）
	/// </summary>
	LeastTime: "0",
	/// <summary>
	/// 步行
	/// </summary>
	Walk: "3"

}//end DriveStyle



